import { trackEvent } from "infra/helpers/event";

enum UnidadeEventsEnum {
  ReenviarEmailSenha = "Reenviar_Email_Senha",
}

export function reenviarEmailSenhaEvent(id: string) {
  trackEvent(UnidadeEventsEnum.ReenviarEmailSenha, { id });
}

const UnidadeEvents = {
  reenviarEmailSenhaEvent
};

export default UnidadeEvents;